import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M17 4L21 8H18V13H16V8H13L17 4ZM3 6V8H8V6H3ZM3 11V13H11V11H3ZM3 16V18H21V16H3Z" }));
export {
  o as ReactComponent
};
